export default __webpack_public_path__ + "static/media/Star.91827d8f.svg";